import { DelayedInlineLoading } from '@metrika/ui-kit';
import React, { PropsWithChildren, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { appEnv } from '../../_env';
import { useIsLogged } from '../../user/hooks';
import { useLoginRequest } from './useLoginRequest';

export function withLogin<P>(Component: React.ComponentType<P>) {
   return function (props: PropsWithChildren<P>): JSX.Element {
      const { userLoading, isLogged } = useIsLogged();
      const location = useLocation();

      useEffect(() => {
         if (!userLoading && !isLogged) {
            window.location.href = `${appEnv.appDomains.login}/login?return_to=${appEnv.appDomains.loginReturnTo + location.pathname}`;
         }
      }, [userLoading, isLogged, location]);
      if (userLoading) return <DelayedInlineLoading />;
      if (isLogged) return <Component {...props} />;
      return <></>;
   };
}

export function withLoginRequest<P>(
   Component: React.ComponentType<P>,
   loginModalProps?: { title?: string; description?: string },
) {
   return function (props: PropsWithChildren<P>): JSX.Element {
      const { userLoading, isLogged, showLoginModal, LoginModal } = useLoginRequest({
         defaultShow: true,
         title: loginModalProps?.title,
         description: loginModalProps?.description,
      });

      if (userLoading) return <DelayedInlineLoading />;
      if (isLogged) return <Component {...props} />;
      return (
         <>
            <div>
               <p>{loginModalProps?.description || 'Please Sign-In to view private content'}</p>
               <Link to={'#'} onClick={showLoginModal}>
                  Sign-In
               </Link>
            </div>
            <LoginModal />
         </>
      );
   };
}
